<template lang="">
  <div>
    <div class='live-pc'  style='display: none;'>
      <my-header color='#333'></my-header>
      <div class='content'>
        <h1 class='topic-top'>{{ $t('liveAll.content1') }}</h1>
        <ul class='topic-ul'>
          <a :href="'/live/' + item.lgid +'.html'" class='pc-live-items'
            v-for="(item,index) in hotOnlineList.slice(0,6)" :key="index">
            <img :src="item.live_pic||item.avatar" alt="">
            <div class='pc-live-content'>
              <span>{{item.nickname}}</span>
              <span>
                <van-icon name="user-o" color='#a8a8a8' size='14px' />{{item.view_num}}
              </span>
            </div>
          </a>
        </ul>
        <p class='topic-top'>{{ $t('liveAll.content2') }}</p>
        <ul class='topic-ul'>
          <a :href="'/live/' + item.lgid +'.html'" class='pc-live-items' v-for="(item,index) in hotOnlineList"
            :key="index">
            <img :src="item.live_pic||item.avatar" alt="">
            <div class='pc-live-content'>
              <span>{{item.nickname}}</span>
              <span>
                <van-icon name="user-o" color='#a8a8a8' size='14px' />{{item.view_num}}
              </span>
            </div>
          </a>
        </ul>
      </div>
      <!-- 底部 -->
      <my-footer></my-footer>
    </div>
    <div class='mobile'>
      <h1 class='mobile-title'>{{ $t('liveAll.content1') }}</h1>
      <ul class='topic-box'>
        <li class='live-items' v-for="(item,index) in hotOnlineList.slice(0,6)" :key="index">
          <a :href="'/live/' + item.lgid + '.html'">
            <img :src="item.live_pic||item.avatar" alt="">
            <div class='live-content'>
              <span>{{item.nickname}}</span>
              <span>
                <van-icon name="user-o" />{{item.view_num}}
              </span>
            </div>
          </a>
        </li>
      </ul>
      <h1 class='mobile-title'>{{ $t('liveAll.content2') }}</h1>
      <ul class='topic-box'>
        <li class='live-items' v-for="(item,index) in hotOnlineList" :key="index">
          <a :href="'/live/' + item.lgid + '.html'">
            <img :src="item.live_pic||item.avatar" alt="">
            <div class='live-content'>
              <span>{{item.nickname}}</span>
              <span>
                <van-icon name="user-o" />{{item.view_num}}
              </span>
            </div>
          </a>
        </li>
      </ul>
      <mobilefoot></mobilefoot>
      <my-menu color="#000"></my-menu>
    </div>
  </div>

</template>
<script>
  import Vue from "vue";
  import ajax from "Common/ajax";
  import constans from "Constans";
  import Utils from "Common/util";
  import cookie from "Common/cookie";
  import myHeader from 'Views/components/header'
  import myFooter from 'Views/components/foot'
  import mobilefoot from 'Views/components/mobilefoot'
  import myMenu from 'Views/components/menu'
  import VueMeta from 'vue-meta'
  import { Icon } from 'vant';
  Vue.use(VueMeta)
  Vue.use(Icon);
  const userUrl = constans.AllUrl.url.dev;
  export default {
    name: 'app',
    components: {
      myHeader,
      myFooter,
      mobilefoot,
      myMenu
    },
    data() {
      return {
        hotOnlineList: [],
        canonicalUrl: '',
        title: '',
        desc: '',
      }
    },
    metaInfo() {
      return {
        title: this.title,
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.desc
          }
        ],
        link: [
          {
            ref: "canonical",
            href: this.canonicalUrl
          },
        ]
      }
    },
    created() {
      const that = this

      this.fetchData()
      let _arg = Utils.getQueryStringArgs();
      const language = cookie.getCookie('language')
      if (Utils.getLang() =='cn' || _arg.lang == 'zh-Hans-TW' || language == '简体中文') {
        that.canonicalUrl = 'https://www.lespark.cn/live.html?lang=zh-Hant-TW'
        that.title = '在线直播互动 - LesPark'
        that.desc = 'LesPark汇集了众多有趣、有颜、有才的女性主播，您可以实时登陆观看热门直播的精彩视频，LesPark可满足您对于观看高颜值直播、视频交友等多种需求。'
      } else if (Utils.getLang() =='en' || _arg.lang == 'en' || language == 'English') {
        that.canonicalUrl = 'https://www.lespark.cn/live.html?lang=en'
        that.title = 'Lesbian community -  LesPark'
        that.desc = 'LesPark is a collection of popular topics of interest to lesbians, where you can interact with women from all over the world.'
      } else {
        that.canonicalUrl = 'https://www.lespark.cn/live.html'
        that.title = 'Les&拉拉直播 - 在線直播互動 - LesPark'
        that.desc = 'LesPark匯集了眾多有趣、有顏、有才的女性主播，您可以實時登陸觀看熱門直播的精彩視頻，LesPark可滿足您對於觀看高顏值直播、視頻交友等多種需求。'
      }
    },
    mounted() {
      const that = this
      if (!Utils.isPhantomjs()) {
        that.changeType()
      }
      window.addEventListener('resize', Utils.debounce(that.changeType, 1000))
    },
    methods: {
      goLive(id) {
        window.location.href = '/live/' + id + '.html'
      },
      changeType() {
        const that = this
        if (document.documentElement.clientWidth < 960) {
          if (document.getElementsByClassName('mobile')[0]) {
            document.getElementsByClassName('mobile')[0].style.display = 'block'
          }
          if (document.getElementsByClassName('live-pc')[0]) {
            document.getElementsByClassName('live-pc')[0].style.display = 'none'
          }
        } else {
          if (document.getElementsByClassName('mobile')[0]) {
            document.getElementsByClassName('mobile')[0].style.display = 'none'
          }
          if (document.getElementsByClassName('live-pc')[0]) {
            document.getElementsByClassName('live-pc')[0].style.display = 'block'
          }
        }
      },
      fetchData() {
        ajax.Get({
          url: userUrl + "/pc_user_online_lives?t=" + new Date().getTime(),
          headers: {
            bundle_id: 'pc',
            'bundle-id': 'pc',
            lang: 'zh-hans'
          }
        }).then(ref => {
          let data = ref.data;
          this.hotOnlineList = data.online_list;
        }).catch(ref => {
        })
      },
    },
  }

</script>
<style lang="" scoped>
  .live-pc {
    display: none;
  }

  .content {
    max-width: 1400px;
    min-width: 960px;
    width: 90%;
    position: relative;
    margin: 0 auto;
  }

  .topic-top {
    font-size: 38px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    letter-spacing: 1px;
    margin-bottom: 22px;
    text-align: left;
    width: 100%;
    margin-top: 20px;
  }

  .topic-ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
  }

  .pc-live-items {
    width: 210px;
    height: 250px;
    margin-right: 20px;
    margin-bottom: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
  }

  .pc-live-items>img {
    width: 100%;
    height: 210px;
    border-radius: 8px 8px 0vw 0vw;
    object-fit: cover;
  }

  .pc-live-content {
    font-size: 14px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pc-live-content>span:first-child {
    width: 124px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
  }

  .pc-live-content>span:last-child {
    font-size: 14px;
    color: #a8a8a8;
    display: flex;
    align-items: center;
  }

  /* 移动端 */
  .mobile {
    width: 100vw;
    box-sizing: border-box;
    position: relative;
  }

  .mobile-title {
    height: 12.8vw;
    text-align: left;
    padding-left: 4vw;
    line-height: 12.8vw;
    font-size: 5.0667vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .topic-box {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .topic-box::after {
    content: '';
    height: 0;
    width: 44.6667vw;
  }

  .mobile-topic-txt {
    padding-left: 5.3333vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 4vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    letter-spacing: 1px;
    width: 54vw;
  }

  .live-items {
    width: 44.6667vw;
    height: 56.4vw;
    margin-right: 2.6667vw;
    margin-bottom: 2.6667vw;
  }

  .live-items img {
    width: 100%;
    height: 44.6667vw;
    border-radius: 1.0667vw 1.0667vw 0vw 0vw;
    object-fit: cover;
  }

  .live-content {
    height: 11.7333vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3.7333vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    letter-spacing: 0.1333vw;
  }

  .live-content>span:first-child {
    width: 20.9333vw;
    white-space: nowrap;
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/views/pages/live-all/app.vue